<template>
  <div>
    <!-- login-form-->
    <form>
      <div class="login-box">
        <h1>
          <p><strong>RedWood Health</strong> Care Platform</p>
        </h1>
        <fieldset>
          <input type="text" placeholder="ID" class="input-id" />
          <input type="password" placeholder="Password" class="input-pw" />
          <a class="login-btn" style="color: white">LOGIN</a>
        </fieldset>
        <p class="login_copytxt">Copyright 2018 DKI Technology Co,.Ltd.</p>
      </div>
    </form>
    <div v-show="isLoginLoading">
      <div class="mask-white"></div>
      <div class="login-loading">
        <div class="login-loading-img"></div>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
import { kbAdmin } from '@/api/loginApi';
export default {
  data() {
    return {
      userId: '',
      userName: '',
      isLoginLoading: true,
    };
  },
  created() {
    this.login();
  },
  methods: {
    async login() {
      this.userId = this.$route.query.userId;
      this.userName = this.$route.query.userName;

      // 입력값 검증
      if (
        this.userId === null ||
        this.userId === undefined ||
        this.userId === '' ||
        this.userName === null ||
        this.userName === undefined ||
        this.userName === ''
      ) {
        this.isLoginLoading = false;
        const target = 'userId, userName';
        await this.$dialogs.alert(
          this.$i18n.t('common.alert.invalid-sso-param', { target }),
        );
        this.$router.go(-1);
      }

      // 가입 및 로그인 진행
      const { data } = await kbAdmin(this.userId, this.userName);
      const { valid, message } = data;
      if (!valid) {
        this.$dialogs.alert(this.jsonEscape(message));
      } else {
        // 로그인 성공
        await this.processLoginSuccessful(data);
      }
    },
    // 인증 정보 store 저장
    async processLoginSuccessful(loginResult) {
      if (!loginResult.firstMenuUrl) {
        this.$dialogs.alert(this.$i18n.t('common.alert.noMenu'));
        return false;
      }
      // store에 로그인 정보 저장
      try {
        this.isLoginLoading = true;
        await this.$store.dispatch('auth/LOGIN', loginResult);
        await this.$store.dispatch('common/FETCH_FHIR_CODES');
        await this.$store.dispatch('auth/FETCH_MENU_LIST');
        const split = loginResult.firstMenuUrl.split('/');
        this.$router.push(`/${split[2]}/${split[3]}`);
      } catch (error) {
        console.log('error', error);
      }
    },
  },
};
</script>

<style scoped>
input {
  background: white;
}

.login-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 245px;
  border-radius: 10px;
  padding: 10px 0;
  z-index: 9001;
  text-align: center;
  vertical-align: middle;
}

.login-loading-img {
  width: 150px;
  height: 150px;
  background: url('../../assets/images/Rolling-1s-150px.gif');
  display: inline-block;
  vertical-align: middle;
  scale: 0.5;
}
</style>
